import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 -960 960 960",
  width: "24px",
  fill: "#e8eaed"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M236-656h366v-80q0-51-35.62-87.5t-86.5-36.5q-50.88 0-86.38 36.5Q358-787 358-736H252q0-96 66.69-163T480-966q94.62 0 161.31 67T708-736v80h16q45 0 75.5 30.5T830-550v408q0 45-30.5 75.5T724-36H236q-45 0-75.5-30.5T130-142v-408q0-45 30.5-75.5T236-656Zm0 514h488v-408H236v408Zm244.16-108q38.84 0 66.34-27.66t27.5-66.5q0-38.84-27.66-66.34t-66.5-27.5q-38.84 0-66.34 27.66t-27.5 66.5q0 38.84 27.66 66.34t66.5 27.5ZM236-142v-408 408Z" }, null, -1)
  ]))]))
}
export default { render: render }